import { render, staticRenderFns } from "./x-radio-button-large.vue?vue&type=template&id=467f14a0&scoped=true&"
import script from "./x-radio-button-large.vue?vue&type=script&lang=js&"
export * from "./x-radio-button-large.vue?vue&type=script&lang=js&"
import style0 from "./x-radio-button-large.vue?vue&type=style&index=0&id=467f14a0&prod&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467f14a0",
  null
  
)

export default component.exports